import { Pipe } from '@angular/core';
import { LabelOrAlternativePipe } from './label-or-alternative.pipe';
import { ColorChoices } from '../../../../model/color';

@Pipe({
  name: 'colorOrAlternative',
})
export class ColorOrAlternativePipe extends LabelOrAlternativePipe {
  constructor() {
    super(ColorChoices.OTHER.ordinal);
  }
}
